export default function modalContato (){
    const modalWrapperEl = document.querySelector('.modal-wrapper'); 
    const btnModalEl = document.querySelectorAll('.modal-for-js'); 
    const btnCloseModalEl = document.querySelector('.close-modal'); 
    const form = document.querySelector('.form-demonstrativo'); 

    
    btnModalEl.forEach(btn => {
        btn.addEventListener('click', (e)=>{
            
            e.preventDefault();
            if(btn.nodeName == 'A'){
                handleClickOpen(btn)
            } else {
                handleClickOpen(btn.querySelector('a'))
            }
            
        });
    })

    function handleClickOpen(a){
        // form.name = a.dataset.identificador || 'demonstrativo';
        modalWrapperEl.classList.add('modal-active');
    }

    document.addEventListener('click', (e) => {     
        if(e.target !== modalWrapperEl) return  
            closeModal();    
        })
        btnCloseModalEl.addEventListener('click', ()=>{
        closeModal();
    }); 
    
    function closeModal(){
        modalWrapperEl.classList.remove('modal-active')
    }
}